
import { useEffect, useState } from 'react';
import './rightLoginRegister.css';
import {SlideInfos} from './SlideInfo';

function RightLoginRegister() {
  const [current, setCurrent] = useState(0);
  const [joker, setJoker] = useState(0);
  const [action, setAction] = useState("");
  const [timer, setTimer] = useState(2000);
  const [hover, setHover] = useState(false);
  const [declaredTimeout, setDeclaredTimeout] = useState(null);

  useEffect(() => {
    if (hover){
      if(declaredTimeout){
        clearTimeout(declaredTimeout);
        console.log("hover");
      }
      return;
    }
    let pp = setTimeout(() => {
      nextMove();
      setTimer(prev => prev - 1)
    }, 2000);
    setDeclaredTimeout(pp);
  }, [timer, hover]);

    // useEffect(()=>{
    //     const interval = setInterval(()=>{
    //         nextMove();        
    //     }, 2000);
    //     return () => clearInterval(interval);
    // });

  const nextMove = () => {
    setAction('forward');

    setJoker(current);
    if (current === SlideInfos.length - 1) {
      setCurrent(0);
    } else {
      setCurrent(prev => prev + 1)
    }
  }

  const previousMove = () => {
    setAction('backward');

    setJoker(current);
    if (current === 0) {
      setCurrent(SlideInfos.length - 1);
    } else {
      setCurrent(prev => prev - 1)
    }
  }

  const switchImage = (index) => {
    if (index > current) {
      setAction("forward");
      setJoker(current);
      setCurrent(index);
    } else if (index < current) {
      setAction('backward');
      setJoker(current)
      setCurrent(index)
    }
  }

  // console.log(action + " current " + current + " and joker " + joker);

    return (
        <div className="carousel">
            <div className="logo">
                <img src="/logo.png" alt="" />
            </div>
            <div className="wrapper">
                {
                    SlideInfos.map((slide, index) => (
                        <div key={index} className={["content ", current === index ? "current" : "", joker === index ? " joker" : "", action === "backward" ? " backward" : "", action === "forward" ? " forward" : ""].join('')}>
                            <div className="title">{slide.title}</div>
                            <div className="body">{slide.body}</div>
                        </div>
                    ))
                }
            </div>
            <div className="dotsContainer">
                {
                    Array.from({ length: SlideInfos.length }).map((item, index) => (
                        <div key={index} className={current === index ? 'dot active' : "dot"}></div>
                    ))
                }
            </div>
        </div>
    )
}
export default RightLoginRegister